module.exports = __webpack_public_path__ + "static/media/check-list.cec8ddfc.png";